<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <formEdit
          :key="componentKey"
          :mode="mode"
          :id="id"
          @back="backToList"
          @save="saveData"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import Config from '../../../config/index'
import DataServices from '@/core/DataServices'
import formEdit from './add'
import ApiRepository from "@/core/ApiRepository";
// import moment from "moment-timezone";
// import md5 from 'js-md5'
export default {
  components: {
    formEdit
  },
  data() {
    return {
      validationErrors: [],
      title: "Edit user",
      mode: 'add',
      models: {},
      images: [],
      oldImages: [],
      componentKey: 0,
      page_transaction:null,
      id:null
    }
  },
  async mounted () {
    console.log("this.$route.name:",this.$route.query.page_transaction);
    this.mode = this.$route.name === 'editUser' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Edit user infomation' : this.title;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_USER);
    if (this.mode == 'edit'){
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-users' });
    },
    convertPhone(numberPhone) {
      var phone = numberPhone
      if (numberPhone[0] === '0') {
        phone = phone.substring(1);
      }
      phone = phone.replace(' ', '')
      phone = '+84' + phone
      return phone
    },
    async saveData(params) {
      if (params !== undefined && Object.entries(params).length > 0) {
        var objects = {
          // 'status': 2,
          'fullname': params.fullname,
          'plain_fullname': this.$commonFuction.SkipVN(params.fullname),
          'active': params.active,
          'email': params.email,
          'country_id' : params.country_id,
          'experience_id' : params.experience_id,
        }
        var that = this;

        if (this.mode === 'add') {
          console.log("add")
        //EDIT
        } else  {
          //trường hợp ko chỉnh sửa email
          var uid = this.$route.params.id
          var accountUpdate = {}
          var text_query = ''
          if(params.type_account == 'EMAIL'){
            accountUpdate = {
              'account': params.email
            }
            if(params.password){
              accountUpdate.password = this.$commonFuction.hashPassword(params.password);
              //gọi xóa các token để khi gọi api thì check token
              text_query = `delete_users_devices(where: { uid: {_eq: "${uid}"}}) {
                returning {
                  id
                }
              }`
            }
          }else if(params.active == false){
            text_query = `delete_users_devices(where: { uid: {_eq: "${uid}"}}) {
              returning {
                id
              }
            }`
          }
          
          var main_active_area = params.main_active_area ? params.main_active_area : [];
          var main_insert = []
          for (let i = 0; i < main_active_area.length; i++) {
            const e = main_active_area[i];
            main_insert.push({
              province_id : e.id,
              district_id : (e.is_all == false) ? e.district_id : null,
              uid : uid
            })
          }
          
          var queryUpdate = `
                  mutation update_users_multil($users_object: users_set_input,$accounts_object: accounts_set_input,$users_main_area_object: [users_main_area_insert_input!]!) {
                    update_users(where: { id: {_eq: "${uid}"}}, _set: $users_object) {
                      affected_rows
                      returning {
                        id
                      }
                    }
                    update_accounts(where: { uid: {_eq: "${uid}"}}, _set: $accounts_object) {
                      affected_rows
                      returning {
                        id
                      }
                    }
                    delete_users_main_area(where: { uid: {_eq: "${uid}"}}) {
                      returning {
                        id
                      }
                    }
                    insert_users_main_area(
                      objects: $users_main_area_object
                    ) {
                      returning {
                        id
                      }
                    }
                    `+text_query+`
                  }
            `;

          let variables = {
            users_object: objects,
            accounts_object: accountUpdate,
            users_main_area_object : main_insert
          };
          that.$apollo.mutate({
            mutation: gql(queryUpdate),
            variables: variables
          }).then(async (res) => {
            console.log(res)
            ApiRepository.post(this.$constants.API.UPDATE_MAIN_ACTIVE_USER,{id : uid})
            that.$commonFuction.is_loading(false);
            var router_back = {path: '/admin/list-users'};
            if (!that.$commonFuction.isEmpty(router_back)){
              router_back.query = { page_transaction: that.page_transaction.toString() };
            }
            that.$router.push(router_back);
            that.$toast.add({ severity: 'success', summary: 'Notification', detail: 'Save success', life: 3000 })
          })
        }
      }
    },
    async uploadImagesOld(userID) {
      var s3client = Config.s3Client('user')
      if (this.images && userID) {
        //xoá avatar
        if (this.oldImages.length > 0) await this.deleteAvatar(s3client);

        this.$store.commit('setLoading', true);
        var objects = null;
        for (let index = 0; index < this.images.length; index++) {
          const img = this.images[index];
          let file = img.source
          if (file !== '' && img.file !== '') {
            let fileName = img.name;
            let random = Math.random().toString().slice(2);
            fileName = `${random}_${fileName}`
            await s3client.uploadFile(file, fileName).then((data) => {
              objects = data.location;
            });
          }
        }
        // console.log(objects);
        if (objects !== null) {
          this.$apollo.mutate({
            mutation: DataServices.updateData('users'),
            variables: {
              'data_update': {
                'avatar': objects
              },
              'where_key': {
                'id': {'_eq': userID}
              }
            }
          }).then(() => {
            // console.log('UPDATE AVATAR THANH CONG')
          }).catch((error) => {
            console.error('ERROR: ', error)
          })
        }
      }
    },
    async deleteAvatar(s3client) {
      for (let i = 0; i < this.oldImages.length; i++) {
        let fileName = this.oldImages[i].name
        await s3client.deleteFile(fileName)
      }
    },
    async getData(id) {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('users',{"fields" : `id fullname phone email status active deleted created_at updated_at experience_id country_id role accounts{type} usere_main_area{id province_id district_id province{id province_lang(where: {lang: {_eq: "en"}}){name}} district{id district_lang(where: {lang: {_eq: "en"}}){name}}}`}),
        variables: {
          where_key: {
            id: {'_eq': id}
          }
        },
        fetchPolicy: "network-only"
      })
      console.log("datadata:",data);
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
      }
      this.componentKey++;
    },

  },
  // apollo: {
  //   categories: {
  //     query() {
  //       return DataServices.getList('category', {"fields" : "id name"});
  //     },
  //     update(data) {
  //       return data[Object.keys(data)];
  //     },
  //     fetchPolicy: "network-only"
  //   },
  //   users: {
  //     query() {
  //       return DataServices.getList('users', {"fields" : "id fullname phone"});
  //     },
  //     update(data) {
  //       return data[Object.keys(data)];
  //     },
  //     fetchPolicy: "network-only"
  //   }
  // }
}
</script>

<style lang="scss">
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:450px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;}
      }
      .box-images{ margin-top: 10px; position: relative;
        .item-img{height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative; border: 0.5px solid #ccc;
          &.p-col-5{width: 18%;;}
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain;}
          .button-clear{width: 18px; height: 18px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 5px; padding: 0;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
</style>
<style>
.list-group-v {
  /* display: -webkit-box;
   display: -ms-flexbox;*/
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  /*-ms-flex-direction: column;*/
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
.list-group-item-v:first-child {
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}
.list-group-item-v {
  position: relative;
  display: block;
  padding: .75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(0,0,0,.125) ;
  height: 50px;
}
.box-check-box{
  position: relative;
}
.box-check-box label{
  position: absolute;
  left: 0px;
  top: 2px;
}
.box-check-box .check-box-day{
  position: absolute;
  right: 0px;
  top: 2px;
}
.p-field{
  margin-bottom: 0.5rem!important;
}
</style>